(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["new-collection-template"]) return;
  try {
    
  let card_titles = document.querySelectorAll('.product-grid-title');
  card_titles.forEach((ctitle) => {
    // let trim_size = 20;
    // if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
    //   trim_size = 20;
    //   console.log("on mobile");
    //   console.log(trim_size);
    // }
    // let trimmedString = ctitle.textContent.substring(0, trim_size);
    // ctitle.textContent = trimmedString + '...';
  });

  } catch(e) { console.error(e); }
})();
})();
